<script>
export default {
    name: 'IconArrowheadLeft'
}
</script>
<template>
    <svg
        class="base-icon icon-arrowhead-left"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            d="M41.8 8L18 31.9l.1.099-.1.1L41.8 56l4.2-4.218L26.301 32 46 12.218z"
            fill-rule="evenodd"
        />
    </svg>
</template>
